import React, { FC, lazy } from "react";
import {
  BrowserRouter as Router,
  Switch,
  Route,
  Redirect,
} from "react-router-dom";
import * as AppRoutesConstants from "./routeConstants/appRoutes";
import isAuthenticated from "../shared/components/HOC/requireAuth";
import { RouterProps } from "../shared/types/route.type";
import { nanoid } from "nanoid";
import LazySuspense from "../shared/components/LazySuspense";
import handleAuthRoute from "../shared/components/HOC/handleAuthRoute";

const AuthRouters = lazy(() => import("../views/Auth/authRouters"));
const AuthAppRouter = lazy(() => import("../views/Auth/authAppRouters"));
const AppWrapper = lazy(() => import("../views/App/AppWrapper"));
const TermsAndContionsModal = lazy(
  () => import("../shared/components/TermsAndContionsModal")
);

const { ROOT, AUTH, APP, WILDCARD } = AppRoutesConstants;

interface Props {
  redirectUrl?: string;
}

const AppRoutes = ({ redirectUrl }: Props) => {
  const routes: RouterProps[] = [
    {
      id: "appWrapper",
      exact: false,
      path: APP,
      component: isAuthenticated(AppWrapper),
    },
    {
      id: "authWrapper",
      exact: false,
      path: AUTH,
      component: handleAuthRoute(AuthRouters),
    },
    {
      id: "authAppRouter",
      exact: false,
      path: ROOT,
      component: handleAuthRoute(AuthAppRouter),
    },
  ];

  return (
    <div>
      <Router>
        <LazySuspense>
          <TermsAndContionsModal />
          <Switch>
            {routes.map((route) => (
              <Route
                {...route}
                key={route.id || nanoid()}
                component={route.render ? undefined : (route.component as FC)}
                render={route.render}
              />
            ))}
            <Route path={WILDCARD} render={() => <Redirect to={ROOT} />} />
            {redirectUrl ? <Redirect to={redirectUrl} /> : null}
          </Switch>
        </LazySuspense>
      </Router>
    </div>
  );
};

export default AppRoutes;
